export function getMaxValuePercentageColor(percentage: number) {
  if (percentage >= 50 && percentage <= 100) {
    return '#6ba853'; // green
  } else if (percentage >= 30 && percentage < 50) {
    return '#aeb303'; // yellow
  } else if (percentage >= 10 && percentage < 30) {
    return '#e69138'; // orange
  } else if (percentage >= 0 && percentage < 10) {
    return '#fb262e'; // red
  }
}

export function getMaxValuePercentageLabel(percentage: number) {
  if (percentage >= 50 && percentage <= 100) {
    return 'Calibration was successful. Encoder system is robust to mechanical displacements and temperature expansions.';
  } else if (percentage >= 30 && percentage < 50) {
    return 'Calibration was successful. Encoder system is robust to small mechanical displacements and temperature expansions.';
  } else if (percentage >= 10 && percentage < 30) {
    return 'Calibration was successful. Mechanical displacement and temperature expansions should be avoided.';
  } else if (percentage >= 0 && percentage < 10) {
    return "Phase error is too high. The absolute position can't be computed reliably. Adjust mechanical position and repeat calibration.";
  }
}
